//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import { convertRequestPriority } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'

export default {
  name: 'TasksGroupProposedTasks',
  components: {
    Table
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    group: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      opened: false,
      loading: false,
      formatRequestPriority: convertRequestPriority,

      callback: null,
      header: '',
      proposal: null,
      columns: [
        {
          name: 'included',
          label: 'В группе',
          align: 'left',
          field: 'included',
          sortable: false
        },
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'type',
          label: 'Тип',
          align: 'left',
          field: 'type',
          sortable: true
        },
        {
          name: 'priority',
          label: 'Приоритет',
          align: 'left',
          field: 'priority',
          sortable: true,
          format: this.formatRequestPriority
        },
        {
          name: 'stateName',
          label: 'Состояние',
          align: 'left',
          field: 'stateName',
          sortable: true
        },
        {
          name: 'currentGroupName',
          label: 'Другая группа',
          align: 'left',
          field: 'currentGroupName',
          sortable: true
        }

      ]
    }
  },
  methods: {
    select: function (callback) {
      this.callback = callback
      this.header = this.group ? this.group.name : ''
      this.opened = true

      let url = '/service/delta/request/group/proposeRequests?'
      if (this.group) {
        url = url + 'groupId=' + this.group.id
      } else {
        url = url + 'requestId=' + this.request.requestId
      }

      this.loading = true
      axiosGet({
        url: url,
        onSuccess: (response) => {
          this.proposal = response.data.result
          this.header = this.proposal.groupName
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    confirm: async function () {
      const result = {
        ids: this.proposal.requests.filter(request => request.included === true).map(request => request.id),
        groupName: this.header
      }
      try {
        await this.callback(result)
        this.close()
      } catch (e) {
        console.log(e)
      }
    },
    close () {
      this.opened = false
      this.clearValue()
    },
    clearValue () {
      this.proposal = null
    },

    // renderExecutorName: function (record) {
    //   return !!record.brigadeName ? record.brigadeName : !!record.employeeName ? record.employeeName : ''
    // },
    selectTableItem: function (item) {
      // TODO
    },
    openTableTask: function (task) {
      this.$router.push('/task/' + task.id)
    },
    renameGroup () {
      this.$d_ask({
        callback: (data) => {
          this.header = data.groupName
        },
        header: 'Изменение названия группы заданий',
        propsConfig: {
          groupName: { type: 'text', label: 'Новое название', value: this.header }
        }
      })
    }
  }
}
